import { render, staticRenderFns } from "./Cryptochallenge.vue?vue&type=template&id=12a31fd0"
import script from "./Cryptochallenge.vue?vue&type=script&lang=js"
export * from "./Cryptochallenge.vue?vue&type=script&lang=js"
import style0 from "./Cryptochallenge.vue?vue&type=style&index=0&id=12a31fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports